export default __webpack_public_path__ + "static/media/no-reviews-icon.e9a167a9.png";